import { IPagination } from '@/shared/models/index';
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import Paginate from 'vuejs-paginate';

@Component({
    components: {
        Paginate
    }
})
export default class PaginationComponent extends Vue {

    @Prop() public pagination!: IPagination;

    public get shouldRender(): boolean {

        if (!this.pagination) {

            return false;
        }

        return this.pagination.total > this.pagination.pageSize;
    }

    public get pageCount(): number {

        if (!this.pagination) {

            return 0;
        }

        return Math.ceil(this.pagination.total / this.pagination.pageSize);
    }

    @Emit('pageChanged')
    public emitPageChanged(page: number): number {

        return page;
    }

    public pageChanged(page: number): void {

        this.pagination.page = page;

        this.emitPageChanged(page);
    }
}
